import { useRef } from 'react'
import { com } from '@eidu/web'
import usePermittedActions from '../../io/usePermittedActions'
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction
import PermittedEntityAction = com.eidu.sharedlib.entity.permission.PermittedEntityAction
import EntityId = com.eidu.sharedlib.entity.EntityId

type UseHasPermissionResult = {
  hasPermission: boolean
  loading: boolean
}

const useHasPermission = (entityId: EntityId, requestedAction: EntityAction): UseHasPermissionResult => {
  const requested = useRef([
    new PermittedEntityAction(requestedAction, entityId),
    new PermittedEntityAction(EntityAction.ReadEntity, entityId),
  ])

  const { permissions, isLoading } = usePermittedActions(requested.current)

  return {
    hasPermission:
      permissions?.some(
        (permittedAction) =>
          permittedAction instanceof PermittedEntityAction &&
          permittedAction.target.equals(entityId) &&
          permittedAction.action === requestedAction
      ) || false,
    loading: isLoading,
  }
}

export default useHasPermission
